module.exports = __webpack_public_path__ + "static/media/2-akvagrim.d2cf2372.jpg";